export default __webpack_public_path__ + "static/media/requirements-embedded@3x.033e6e7a.jpg";